import { HomeScreen } from 'screens/home';

export default HomeScreen;
